import { createEntityFilterConfig } from '../../factories/create-entity-filter-config';
import { STATIC_FILTER_ENTITY_TYPES } from '@shared/features/views/components/entities-filters/config';
import memberApi from '@src/shared/services/member-api';
import { MembersFilterOptionItem } from './filter-option-item';

export const membersFilterConfig = ({
  facetName = 'assignee',
}: {
  facetName: string;
}) =>
  createEntityFilterConfig({
    entityType: STATIC_FILTER_ENTITY_TYPES.member,
    facetName,
    fetchInfiniteData: memberApi.useFetchInfinite,
    getValue: (item) => String(item.user.id),
    renderItem: MembersFilterOptionItem,
  });
